{
  "version": 1,
  "style": "Retro pixel art in the style of a 16-bit indie video game. Chunky visible pixels, a small bright saturated palette, bold clean shapes, strong readable silhouettes, simple flat shading. Hand-drawn on a low-resolution pixel grid. Not smooth, not anti-aliased, not 3D-rendered, not photorealistic. No text, no letters, no numbers, no UI, no watermark.",
  "entries": {
    "Marta": {
      "kind": "character",
      "file": "characters/Marta.webp",
      "promptHash": "584113f9e2b2",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-02T22:28:51.749Z"
    },
    "Frida": {
      "kind": "character",
      "file": "characters/Frida.webp",
      "promptHash": "5e53dc534feb",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-03T00:48:33.719Z"
    },
    "Hollow_Atrium": {
      "kind": "room",
      "file": "rooms/Hollow_Atrium.webp",
      "promptHash": "e2a821a337a4",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-07-31T01:27:41.153Z"
    },
    "Tranquil_Pool": {
      "kind": "room",
      "file": "rooms/Tranquil_Pool.webp",
      "promptHash": "5022b26d6500",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-07-31T01:28:03.950Z"
    },
    "Intake": {
      "kind": "room",
      "file": "rooms/Intake.webp",
      "promptHash": "4a8892248319",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-07-31T01:27:24.881Z"
    },
    "June": {
      "kind": "character",
      "file": "characters/June.webp",
      "promptHash": "e38e3364feef",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-03T00:48:41.394Z"
    },
    "Doug": {
      "kind": "character",
      "file": "characters/Doug.webp",
      "promptHash": "80d4850153c4",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-03T00:48:47.665Z"
    },
    "Lana": {
      "kind": "character",
      "file": "characters/Lana.webp",
      "promptHash": "ce3b299e10a3",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-03T00:48:54.138Z"
    },
    "Harold": {
      "kind": "character",
      "file": "characters/Harold.webp",
      "promptHash": "e24d289735dd",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-03T00:49:01.325Z"
    },
    "Greg": {
      "kind": "character",
      "file": "characters/Greg.webp",
      "promptHash": "ffee17f78aa0",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-03T00:49:09.671Z"
    },
    "Foyer": {
      "kind": "room",
      "file": "rooms/Foyer.webp",
      "promptHash": "2f3e62a92a62",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-07-31T01:27:33.184Z"
    },
    "Archive_Lounge": {
      "kind": "room",
      "file": "rooms/Archive_Lounge.webp",
      "promptHash": "938f6ceabe05",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-07-31T01:27:48.519Z"
    },
    "Archive_Console": {
      "kind": "room",
      "file": "rooms/Archive_Console.webp",
      "promptHash": "bb2848b80b31",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-07-31T01:27:56.494Z"
    },
    "Joyous_Cafe": {
      "kind": "room",
      "file": "rooms/Joyous_Cafe.webp",
      "promptHash": "c81b68de7e5f",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-07-31T01:28:12.382Z"
    },
    "Activity_Hub": {
      "kind": "room",
      "file": "rooms/Activity_Hub.webp",
      "promptHash": "5cabdd3a5b69",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-07-31T01:28:21.038Z"
    },
    "Solitude_Cubes": {
      "kind": "room",
      "file": "rooms/Solitude_Cubes.webp",
      "promptHash": "ff34867d70f5",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-07-31T01:28:29.132Z"
    },
    "Hallway": {
      "kind": "room",
      "file": "rooms/Hallway.webp",
      "promptHash": "db6b0b05a0a8",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-07-31T01:28:35.865Z"
    },
    "Milton": {
      "kind": "character",
      "file": "characters/Milton.webp",
      "promptHash": "1c9a2c9c34e6",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-03T00:49:17.216Z"
    },
    "Gloria": {
      "kind": "character",
      "file": "characters/Gloria.webp",
      "promptHash": "2fef8785a44a",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-03T00:49:25.039Z"
    },
    "Lily": {
      "kind": "character",
      "file": "characters/Lily.webp",
      "promptHash": "d6e6b57dceb9",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-03T00:49:33.120Z"
    },
    "Henry": {
      "kind": "character",
      "file": "characters/Henry.webp",
      "promptHash": "95bdea23853b",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-03T00:49:40.765Z"
    },
    "Yellow_Room": {
      "kind": "room",
      "file": "rooms/Yellow_Room.webp",
      "promptHash": "15e8213f21e3",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:38:20.728Z"
    },
    "Nursery": {
      "kind": "room",
      "file": "rooms/Nursery.webp",
      "promptHash": "7f919f2c3232",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:38:28.837Z"
    },
    "Ill_Fitting_Lounge": {
      "kind": "room",
      "file": "rooms/Ill_Fitting_Lounge.webp",
      "promptHash": "11b61d0abe18",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:38:36.869Z"
    },
    "Feedback_Booth": {
      "kind": "room",
      "file": "rooms/Feedback_Booth.webp",
      "promptHash": "21e58b1fc5fc",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:38:44.399Z"
    },
    "Static_Garden": {
      "kind": "room",
      "file": "rooms/Static_Garden.webp",
      "promptHash": "2fcbe9f99bb1",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:38:51.994Z"
    },
    "Quiet_Plaza": {
      "kind": "room",
      "file": "rooms/Quiet_Plaza.webp",
      "promptHash": "dcd8ab29f86f",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:38:59.641Z"
    },
    "Waiting_Room": {
      "kind": "room",
      "file": "rooms/Waiting_Room.webp",
      "promptHash": "634a6d8ec4f3",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:39:07.967Z"
    },
    "Quarters_Doug": {
      "kind": "room",
      "file": "rooms/Quarters_Doug.webp",
      "promptHash": "d109555d2a13",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:39:16.046Z"
    },
    "Quarters_Marta": {
      "kind": "room",
      "file": "rooms/Quarters_Marta.webp",
      "promptHash": "814513700d6a",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:39:23.542Z"
    },
    "Quarters_Frida": {
      "kind": "room",
      "file": "rooms/Quarters_Frida.webp",
      "promptHash": "bc1de9c545bc",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:39:31.840Z"
    },
    "Quarters_June": {
      "kind": "room",
      "file": "rooms/Quarters_June.webp",
      "promptHash": "93155f281240",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:39:39.565Z"
    },
    "Quarters_Lana": {
      "kind": "room",
      "file": "rooms/Quarters_Lana.webp",
      "promptHash": "c0a75e032cfd",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:39:48.206Z"
    },
    "Quarters_Harold": {
      "kind": "room",
      "file": "rooms/Quarters_Harold.webp",
      "promptHash": "d4ae70adeac4",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:39:57.856Z"
    },
    "Quarters_Greg": {
      "kind": "room",
      "file": "rooms/Quarters_Greg.webp",
      "promptHash": "5c1b9f7a44e2",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:40:05.280Z"
    },
    "Quarters_Milton": {
      "kind": "room",
      "file": "rooms/Quarters_Milton.webp",
      "promptHash": "1c3ce5efee10",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:40:13.099Z"
    },
    "Quarters_Gloria": {
      "kind": "room",
      "file": "rooms/Quarters_Gloria.webp",
      "promptHash": "f91278fc1952",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:40:21.385Z"
    },
    "Quarters_Lily": {
      "kind": "room",
      "file": "rooms/Quarters_Lily.webp",
      "promptHash": "d95a1cc02d97",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:40:29.333Z"
    },
    "Quarters_Henry": {
      "kind": "room",
      "file": "rooms/Quarters_Henry.webp",
      "promptHash": "85a95082e5f6",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:40:37.136Z"
    },
    "Quarters_Yours": {
      "kind": "room",
      "file": "rooms/Quarters_Yours.webp",
      "promptHash": "95fd3356fe17",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:40:44.311Z"
    },
    "Reflection_Chamber": {
      "kind": "room",
      "file": "rooms/Reflection_Chamber.webp",
      "promptHash": "3d7d225ba775",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:40:51.530Z"
    },
    "Utility_Closet": {
      "kind": "room",
      "file": "rooms/Utility_Closet.webp",
      "promptHash": "e11a0702dc06",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-01T17:40:59.612Z"
    },
    "Archivist": {
      "kind": "character",
      "file": "characters/Archivist.webp",
      "promptHash": "578f8eeaa5bb",
      "model": "google/gemini-2.5-flash-image",
      "generated": "2026-08-03T00:54:24.529Z"
    }
  }
}
